/* eslint-disable import/first */
import React, { useState } from 'react';
import { IntlProvider } from 'react-intl';
import Cookies from 'js-cookie';
import { Helmet } from 'react-helmet';
import { getDefaultCountryValues } from 'spwa-ui-library/esm/utils/helper';
import Arabic from '../../lang/ar.json';
import English from '../../lang/en.json';

export const Context = React.createContext();

const languageMap = {
  en: English,
  'en-US': English,
  'en-UK': English,
  ar: Arabic,
};

const Wrapper = (props) => {
  // TODO: Place check for URL, navigator.language
  // Order - url, cookie, navigator.language, config default, 'en'
  const selection = getDefaultCountryValues();
  const defaultLocale = Cookies.get('local') || selection.defaultLang.toLowerCase();
  const [locale, setLocale] = useState(defaultLocale);
  const [messages, setMessages] = useState(languageMap[defaultLocale]);
  // const [countryDrawer, setCountryDrawer] = useState(false);
  // function openCountryDrawer(setState) {
  //   setCountryDrawer(setState);
  // }
  // eslint:fix openCountryDrawer is defined but never used
  function selectLanguage(selectedLocale) {
    if (!selectedLocale || locale === selectedLocale) return;
    const newLocale = selectedLocale;
    if (languageMap[newLocale]) {
      Cookies.set('local', newLocale, { expires: 365 });
      setMessages(languageMap[newLocale]);
      setLocale(newLocale);
    }
  }
  // <MultiCountryPopUp open={countryDrawer} onClose={openCountryDrawer(false)}>
  //   <SwipeableCountryDrawer
  //     title={<FormattedMessage id="changeCountry" defaultMessage="Change Country" />}
  //     dataList={countryList}
  //     switchCountry={switchCountry}
  //     onClickHandler={selectCountry}
  //     //onButtonClick={changeCountry}
  //     onCountrySelected={saveCountryStatus}
  //     loadingStatus={saveLoadingStatus}
  //   />
  // </MultiCountryPopUp>;
  return (
    <>
      <Helmet>
        <html dir={locale === 'ar' ? 'rtl' : 'ltr'} lang={locale} />
      </Helmet>
      <Context.Provider value={{ locale, selectLanguage }}>
        <IntlProvider key={locale} messages={messages} locale={locale}>
          {props.children}
        </IntlProvider>
      </Context.Provider>
    </>
  );
};

export default Wrapper;
